import { atom } from "recoil";

export const ScheduleZoomInState = atom<number | null>({
  key: "scheduleZoomInState",
  default: null,
});
